<div class="bd-highlight mb-3">
  <h3
    class="me-auto p-2 bd-highlight rb-details-toggle"
    rbDetailsToggle
    [isOpen]="getGroupIsOpen()"
    (isOpenChange)="onGroupToggleChange($event)"
    #triggerDetails="rbDetailsToggle"
    data-cy="group-title">
    {{ groupModel().group | titlecase }}
  </h3>

  @if (triggerDetails.open) {
    @for (product of groupModel().productOptions; track product.name) {
      @if (checkIfAdminOfProduct(product)) {
        <app-user-table
          [group]="groupModel().group"
          [productOption]="product"
          [members]="getMembersOfProduct(groupModel().members, product)" />
        <br />
      }
    }
  }
</div>
